export default __webpack_public_path__ + "static/pump_w.0e203721ae35ebbcbc622c298e70d222.png";